import React, {Component} from 'react';
import { Modal,  } from 'react-bootstrap'
import SearchCarBox from './SearchCarBox';

class SearchCarButton extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  
  render(){
    let {show,onHide,onSelect} = this.props
    
    return(
      <Modal
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {'ค้นหาทะเบียนรถ'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SearchCarBox onSelect={onSelect} onHide={onHide} affId={this.props.affId} onAffChange={this.props.onAffChange} />          
        </Modal.Body>
      </Modal>
    )  
  }
}
SearchCarButton.defaultProps = {
  show:false
}
export default SearchCarButton


// WEBPACK FOOTER //
// ./src/component/element/SearchCarButton.js